import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ModalBaseModule } from 'Angular/features/components/modals/modal-base/modal-base.module';

import { HelpModalComponent } from './components/help-modal.component';
import { HelpModalWithTriggerComponent } from './components/help-modal-with-trigger.component';

@NgModule({
    declarations: [HelpModalComponent, HelpModalWithTriggerComponent],
    imports: [CommonModule, ModalBaseModule],
    exports: [HelpModalComponent, HelpModalWithTriggerComponent],
})
export class HelpModalModule {}
